import React from 'react';
import { SortableElement, sortableHandle } from 'react-sortable-hoc';
import { Switch, Button, Icon } from 'components';
import styles from 'styles/extra_modules.module.scss';
import classNames from 'lib/classNames';

const Module = SortableElement(
	({ module, name, reset, switchButton = true, resetModule, moduleKey, children, context, info }) => {
		const active = module && typeof module.active === 'boolean' ? module.active : true;

		return (
			<div className={styles.module} data-active={active}>
				<div className={styles.header} data-has-children={!!children}>
					<div className={styles.header_wrapper}>
						<b className={styles.name}>{name}</b>
						{reset && (
							<Button
								text="Reset"
								icon="undo"
								type="link"
								size="small"
								className={styles.ml_4}
								onClick={() => resetModule(moduleKey)}
							/>
						)}
						{switchButton && (
							<Switch
								className={styles.ml_4}
								BindToContext={[context, `settings.modules.${moduleKey}.active`]}
							/>
						)}
					</div>
					{!!info && <p className={styles.info}>{info}</p>}
				</div>
				{!!children && (
					<div
						className={`${styles.content} ${!active ? styles.collapsed : ''}`}
						style={{
							overflow: active ? 'initial' : 'hidden',
						}}
					>
						<div className={styles.inner}>{children}</div>
					</div>
				)}
				<Grip active={active} />
			</div>
		);
	}
);

Module.defaultProps = {
	switchButton: true,
	reset: true,
};

const Grip = sortableHandle(({ active }) => {
	return (
		<div className={styles.grip} data-active={active}>
			<Icon icon="angle-up" />
			<Icon icon="angle-down" />
		</div>
	);
});

export default Module;
